import React from "react";

const DashboardView = () => {
  return <div>DashboardView</div>;
};

export default DashboardView;
